//index.js
import CreditTerms from './CreditTerms';
import AdditionalConsents from './AdditionalConsents';
import SurchargesApplication from './SurchargesApplication';
import AnimalProduction from './AnimalProduction';
import AdditionalIncome from './AdditionalIncome';
import FinancialBurdens from './FinancialBurdens';
import FinancialSector from './FinancialSector';
import AdditionalDocuments from './AdditionalDocuments';
import Summary from './Summary';

export {
  CreditTerms,
  AdditionalConsents,
  SurchargesApplication,
  AnimalProduction,
  AdditionalIncome,
  FinancialBurdens,
  FinancialSector,
  AdditionalDocuments,
  Summary,
};
